import { createContext } from 'react';
import { defaultState } from './reducer';

const Context = createContext({
  ...defaultState,
  isAuthorized: (action: string): boolean => {
    return false;
  },
});

export default Context;
